import React from 'react';
import { IconSvgProps } from '@models/common';

const ArrowRight: React.FC<IconSvgProps> = (props) => {
  const { size = 18, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 18 18'
      fill='none'>
      <path
        fill='currentColor'
        d='M12.687 8.25 8.663 4.227l1.061-1.06L15.557 9l-5.833 5.834-1.06-1.061 4.023-4.023h-9.13v-1.5h9.13Z'
      />
    </svg>
  );
};

export default ArrowRight;
